import { Component, KeyValueDiffers, OnInit,KeyValueDiffer,DoCheck, Input, Renderer2, ComponentFactoryResolver } from '@angular/core';
import { FormArray, FormBuilder, NgForm, FormGroup, FormControl,Validators  } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CommonData, Post, settingPayLoad, Settings } from 'src/app/shared/classes/Settings';
import { EmailConfigService } from 'src/app/shared/services/emailconfig.service';
//import { SystemService } from 'src/app/shared/services/system.service';


@Component({
  selector: 'app-email-configuration',
  templateUrl: './email-configuration.component.html',
  styleUrls: ['./email-configuration.component.less']
})
export class EmailConfigurationComponent implements OnInit {
  items:FormArray;
  SettingsDetails:Settings;
  config:settingPayLoad[];
  EnableEmail:boolean;
  //constructor() { }
  constructor(private toast: ToastrService,private _emailconfigService:EmailConfigService) {
   // _systemService:SystemService
 this.SettingsDetails= new Settings();
 //this.ComnSettingsData=[];
   }

  ngOnInit(): void {
    this.GetEmailConfigurationData();
  }

  GetEmailConfigurationData()
  {

    this._emailconfigService.getEmailConfigurationData().subscribe(
      resultArray => {
        resultArray.forEach((item)=>{
        })
       // this.SettingsDetails=resultArray;
      //  console.log(resultArray);

       this.SettingsDetails.SMTPPort=resultArray.filter(config=>config.configurationName === 'SMTPPort')[0].configurationValue;
       this.SettingsDetails.SMTPHost=resultArray.filter(config=>config.configurationName === 'SMTPHost')[0].configurationValue;
       this.SettingsDetails.EnableEmailNotification=resultArray.filter(config=>config.configurationName === 'EnableEmailNotification')[0].configurationValue;
      //  console.log(this.SettingsDetails.EnableEmailNotification);
        if(this.SettingsDetails.EnableEmailNotification=='true'){
        this.EnableEmail=true;
       }
       else{
        this.EnableEmail=false;
       }
       this.SettingsDetails.EmailNotificationFrom=resultArray.filter(config=>config.configurationName === 'EmailNotificationFrom')[0].configurationValue;
       this.SettingsDetails.EmailDeliveryAttempts=resultArray.filter(config=>config.configurationName === 'EmailDeliveryAttempts')[0].configurationValue;
       this.SettingsDetails.DefaultEmailSubjectforTSS=resultArray.filter(config=>config.configurationName === 'DefaultEmailSubjectforTSS')[0].configurationValue;
       this.SettingsDetails.DefaultEmailSubjectforSummary=resultArray.filter(config=>config.configurationName === 'DefaultEmailSubjectforSummary')[0].configurationValue;
    })
  
   

  }
  Reset()
  {
  this.GetEmailConfigurationData();
  }

 onSubmit(formdata: NgForm) {

 this.config = [];
 let SMTPPort={} as settingPayLoad;
 SMTPPort.configurationName='SMTPPort';
 SMTPPort.configurationValue=this.SettingsDetails.SMTPPort;
 this.config.push(SMTPPort);

 let SMTPHost={} as settingPayLoad;
 SMTPHost.configurationName='SMTPHost';
 SMTPHost.configurationValue=this.SettingsDetails.SMTPHost;
 this.config.push(SMTPHost);

 let EnableEmailNotification={} as settingPayLoad;
 EnableEmailNotification.configurationName='EnableEmailNotification';
 EnableEmailNotification.configurationValue = String(this.SettingsDetails.EnableEmailNotification);
 this.config.push(EnableEmailNotification);

 let EmailNotificationFrom={} as settingPayLoad;
 EmailNotificationFrom.configurationName='EmailNotificationFrom';
 EmailNotificationFrom.configurationValue=this.SettingsDetails.EmailNotificationFrom;
 this.config.push(EmailNotificationFrom);

 let EmailDeliveryAttempts={} as settingPayLoad;
 EmailDeliveryAttempts.configurationName='EmailDeliveryAttempts';
 EmailDeliveryAttempts.configurationValue=this.SettingsDetails.EmailDeliveryAttempts;
 this.config.push(EmailDeliveryAttempts);

  
 let DefaultEmailSubjectforTSS={} as settingPayLoad;
 DefaultEmailSubjectforTSS.configurationName='DefaultEmailSubjectforTSS';
 DefaultEmailSubjectforTSS.configurationValue=this.SettingsDetails.DefaultEmailSubjectforTSS;
 this.config.push(DefaultEmailSubjectforTSS);

 let DefaultEmailSubjectforSummary={} as settingPayLoad;
 DefaultEmailSubjectforSummary.configurationName='DefaultEmailSubjectforSummary';
 DefaultEmailSubjectforSummary.configurationValue=this.SettingsDetails.DefaultEmailSubjectforSummary;
 this.config.push(DefaultEmailSubjectforSummary);
  
  this._emailconfigService.UpdateEmailConfigurationData(this.config).subscribe(result=>{
    // this.oldSettings=[];
    this.toast.success("Email details updated Successfully" , '', {
      'positionClass': 'toast-bottom-center'
    });    
  })
 }
}